"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function getCurrentSelectionConfiguration(state) {
    if (state.activeAdditionalCategory === 'NONE') {
        return null;
    }
    return lodash_1.find(state.selectionCategoryConfigurations, {
        mainCategory: state.cabinCategory,
    });
}
exports.getCurrentSelectionConfiguration = getCurrentSelectionConfiguration;
function getCurrentSelectionConfigurationIndex(state) {
    if (state.activeAdditionalCategory === 'NONE') {
        return null;
    }
    return lodash_1.findIndex(state.selectionCategoryConfigurations, {
        mainCategory: state.cabinCategory,
    });
}
exports.getCurrentSelectionConfigurationIndex = getCurrentSelectionConfigurationIndex;
exports.default = {
    getCurrentSelectionConfiguration: getCurrentSelectionConfiguration,
    getCurrentSelectionConfigurationIndex: getCurrentSelectionConfigurationIndex,
};
//# sourceMappingURL=helper.js.map